var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero",class:_vm.type,style:(_vm.backgroundStyle),attrs:{"aria-label":_vm.header}},[_c('div',{staticClass:"hero-content"},[_c('h2',{staticClass:"hero-content-header",domProps:{"innerHTML":_vm._s(_vm.header)}}),_c('p',{staticClass:"hero-content-text",domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }